wp.i18n.setLocaleData( { '': {} }, 'essential-content-types-pro' );
